var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: { visible: _vm.value, title: "切换环境", width: "600" },
      on: { close: _vm.handleCancel },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function() {
            return [
              _c("el-button", { on: { click: _vm.handleCancel } }, [
                _vm._v("取消")
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSave } },
                [_vm._v("确定")]
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c("div", { staticStyle: { "line-height": "40px" } }, [
        _vm._v("ERP请求域名：")
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 3 } },
            [
              _c("el-button", { attrs: { type: "text" } }, [
                _vm._v(_vm._s(_vm.protocolMap[_vm.requestConfig.erpSuffix]))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 21 } },
            [
              _c("el-input", {
                attrs: { placeholder: "需求编号或数字", clearable: "" },
                scopedSlots: _vm._u([
                  {
                    key: "prepend",
                    fn: function() {
                      return [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "150px" },
                            model: {
                              value: _vm.requestConfig.erpHost,
                              callback: function($$v) {
                                _vm.$set(_vm.requestConfig, "erpHost", $$v)
                              },
                              expression: "requestConfig.erpHost"
                            }
                          },
                          [
                            _c("el-option", { attrs: { value: "erp-feat-" } }, [
                              _vm._v("erp-feat-")
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-option",
                              { attrs: { value: "erp-stable" } },
                              [_vm._v("erp-stable")]
                            )
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "append",
                    fn: function() {
                      return [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "180px" },
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.requestConfig.erpSuffix,
                              callback: function($$v) {
                                _vm.$set(_vm.requestConfig, "erpSuffix", $$v)
                              },
                              expression: "requestConfig.erpSuffix"
                            }
                          },
                          _vm._l(_vm.SUFFIX_OPTIONS, function(item) {
                            return _c(
                              "el-option",
                              { key: item.value, attrs: { value: item.value } },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(item.label) +
                                    "\n            "
                                )
                              ]
                            )
                          }),
                          1
                        )
                      ]
                    },
                    proxy: true
                  }
                ]),
                model: {
                  value: _vm.requestConfig.erpEnv,
                  callback: function($$v) {
                    _vm.$set(_vm.requestConfig, "erpEnv", $$v)
                  },
                  expression: "requestConfig.erpEnv"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticStyle: { "line-height": "40px" } }, [
        _vm._v("OS请求域名：")
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 3 } },
            [
              _c("el-button", { attrs: { type: "text" } }, [
                _vm._v(_vm._s(_vm.protocolMap[_vm.requestConfig.osSuffix]))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 21 } },
            [
              _c("el-input", {
                attrs: { placeholder: "需求编号或数字", clearable: "" },
                scopedSlots: _vm._u([
                  {
                    key: "prepend",
                    fn: function() {
                      return [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "150px" },
                            model: {
                              value: _vm.requestConfig.osHost,
                              callback: function($$v) {
                                _vm.$set(_vm.requestConfig, "osHost", $$v)
                              },
                              expression: "requestConfig.osHost"
                            }
                          },
                          [
                            _c("el-option", { attrs: { value: "os-feat-" } }, [
                              _vm._v("os-feat-")
                            ]),
                            _vm._v(" "),
                            _c("el-option", { attrs: { value: "os-stable" } }, [
                              _vm._v("os-stable")
                            ])
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "append",
                    fn: function() {
                      return [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "180px" },
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.requestConfig.osSuffix,
                              callback: function($$v) {
                                _vm.$set(_vm.requestConfig, "osSuffix", $$v)
                              },
                              expression: "requestConfig.osSuffix"
                            }
                          },
                          _vm._l(_vm.SUFFIX_OPTIONS, function(item) {
                            return _c(
                              "el-option",
                              { key: item.value, attrs: { value: item.value } },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(item.label) +
                                    "\n            "
                                )
                              ]
                            )
                          }),
                          1
                        )
                      ]
                    },
                    proxy: true
                  }
                ]),
                model: {
                  value: _vm.requestConfig.osEnv,
                  callback: function($$v) {
                    _vm.$set(_vm.requestConfig, "osEnv", $$v)
                  },
                  expression: "requestConfig.osEnv"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticStyle: { "line-height": "40px" } }, [
        _vm._v("微服务请求域名：")
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 3 } },
            [
              _c("el-button", { attrs: { type: "text" } }, [
                _vm._v(_vm._s(_vm.protocolMap[_vm.requestConfig.gatewaySuffix]))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 21 } },
            [
              _c("el-input", {
                attrs: { placeholder: "需求编号或数字", clearable: "" },
                scopedSlots: _vm._u([
                  {
                    key: "prepend",
                    fn: function() {
                      return [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "150px" },
                            model: {
                              value: _vm.requestConfig.gatewayHost,
                              callback: function($$v) {
                                _vm.$set(_vm.requestConfig, "gatewayHost", $$v)
                              },
                              expression: "requestConfig.gatewayHost"
                            }
                          },
                          [
                            _c(
                              "el-option",
                              { attrs: { value: "gateway-dev" } },
                              [_vm._v("gateway-dev")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-option",
                              { attrs: { value: "gateway-pre" } },
                              [_vm._v("gateway-pre(预发布)")]
                            )
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "append",
                    fn: function() {
                      return [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "180px" },
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.requestConfig.gatewaySuffix,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.requestConfig,
                                  "gatewaySuffix",
                                  $$v
                                )
                              },
                              expression: "requestConfig.gatewaySuffix"
                            }
                          },
                          _vm._l(_vm.SUFFIX_OPTIONS, function(item) {
                            return _c(
                              "el-option",
                              { key: item.value, attrs: { value: item.value } },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(item.label) +
                                    "\n            "
                                )
                              ]
                            )
                          }),
                          1
                        )
                      ]
                    },
                    proxy: true
                  }
                ]),
                model: {
                  value: _vm.requestConfig.gatewayEnv,
                  callback: function($$v) {
                    _vm.$set(_vm.requestConfig, "gatewayEnv", $$v)
                  },
                  expression: "requestConfig.gatewayEnv"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticStyle: { "line-height": "40px" } }, [
        _vm._v("API请求域名：")
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 3 } },
            [
              _c("el-button", { attrs: { type: "text" } }, [
                _vm._v(_vm._s(_vm.protocolMap[_vm.requestConfig.apiSuffix]))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 21 } },
            [
              _c("el-input", {
                attrs: { placeholder: "需求编号或数字", clearable: "" },
                scopedSlots: _vm._u([
                  {
                    key: "prepend",
                    fn: function() {
                      return [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "150px" },
                            model: {
                              value: _vm.requestConfig.apiHost,
                              callback: function($$v) {
                                _vm.$set(_vm.requestConfig, "apiHost", $$v)
                              },
                              expression: "requestConfig.apiHost"
                            }
                          },
                          [
                            _c("el-option", { attrs: { value: "api-feat-" } }, [
                              _vm._v("api-feat-")
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-option",
                              { attrs: { value: "api-stable" } },
                              [_vm._v("api-stable")]
                            )
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "append",
                    fn: function() {
                      return [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "180px" },
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.requestConfig.apiSuffix,
                              callback: function($$v) {
                                _vm.$set(_vm.requestConfig, "apiSuffix", $$v)
                              },
                              expression: "requestConfig.apiSuffix"
                            }
                          },
                          _vm._l(_vm.SUFFIX_OPTIONS, function(item) {
                            return _c(
                              "el-option",
                              { key: item.value, attrs: { value: item.value } },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(item.label) +
                                    "\n            "
                                )
                              ]
                            )
                          }),
                          1
                        )
                      ]
                    },
                    proxy: true
                  }
                ]),
                model: {
                  value: _vm.requestConfig.apiEnv,
                  callback: function($$v) {
                    _vm.$set(_vm.requestConfig, "apiEnv", $$v)
                  },
                  expression: "requestConfig.apiEnv"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("el-divider"),
      _vm._v(" "),
      _c("div", { staticStyle: { "line-height": "40px" } }, [
        _vm._v("跳转到OS后台域名：")
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 3 } },
            [
              _c("el-button", { attrs: { type: "text" } }, [
                _vm._v(_vm._s(_vm.protocolMap[_vm.requestConfig.oswebSuffix]))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 21 } },
            [
              _c("el-input", {
                attrs: { placeholder: "需求编号或数字", clearable: "" },
                scopedSlots: _vm._u([
                  {
                    key: "prepend",
                    fn: function() {
                      return [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "150px" },
                            model: {
                              value: _vm.requestConfig.oswebHost,
                              callback: function($$v) {
                                _vm.$set(_vm.requestConfig, "oswebHost", $$v)
                              },
                              expression: "requestConfig.oswebHost"
                            }
                          },
                          [
                            _c(
                              "el-option",
                              { attrs: { value: "osweb-feat-" } },
                              [_vm._v("osweb-feat-")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-option",
                              { attrs: { value: "osweb-stable" } },
                              [_vm._v("osweb-stable")]
                            )
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "append",
                    fn: function() {
                      return [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "180px" },
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.requestConfig.oswebSuffix,
                              callback: function($$v) {
                                _vm.$set(_vm.requestConfig, "oswebSuffix", $$v)
                              },
                              expression: "requestConfig.oswebSuffix"
                            }
                          },
                          _vm._l(_vm.SUFFIX_OPTIONS, function(item) {
                            return _c(
                              "el-option",
                              { key: item.value, attrs: { value: item.value } },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(item.label) +
                                    "\n            "
                                )
                              ]
                            )
                          }),
                          1
                        )
                      ]
                    },
                    proxy: true
                  }
                ]),
                model: {
                  value: _vm.requestConfig.oswebEnv,
                  callback: function($$v) {
                    _vm.$set(_vm.requestConfig, "oswebEnv", $$v)
                  },
                  expression: "requestConfig.oswebEnv"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2042a073", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2042a073","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EnvModal/index.vue
// module id = null
// module chunks = 